import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/layout/search.scss'; 
import magGlass from '../icons/magnifying-glass.svg'
import cross from '../icons/cross.svg';

const Search = () => {
  const [query, setQuery] = useState('');
  const [search_option, setSearchOption] = useState('');
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(false);

  const search_options = [
    { id: 'product', name: 'Product'},
    { id: 'recipe', name: 'Recipe'},
  ];

  const post_types = ['post', 'recipe', 'product'];

  const API_URL = '/wp-json/wp/v2'; // Replace with your WordPress API endpoint.

  useEffect(() => {
    if (query) {
      switch (search_option){
        case 'product':
        case 'recipe':
          axios
          .get(`${API_URL}/${search_option}`, {
            params: {
              search: query,
              subtype: post_types,
            },
          })
          .then((response) => {
            console.log(response.data);
            const modifiedData = response.data.map((post) => {
              post.product_size = post.acf.product_size;
              post.id = post.id;
              post.url = post.link;
              post.subtype = post.type;
              post.title = (post.subtype === 'product') ? `${post.title.rendered} - ${post.product_size}` : post.title.rendered;
              return post;
            })
            console.log('modifiedData',modifiedData);
            setPosts(modifiedData);
          })
          .catch((error) => {
            console.error('Error fetching posts:', error);
          });
          break;
        default:
          axios
            .get(`${API_URL}/search`, {
              params: {
                search: query,
                subtype: post_types,
              },
            })
            .then((response) => {
              console.log(response);
              console.log(response.data);
              const modifiedData = response.data.map((result) => {
                result.title = (result.subtype === 'product') ? `${result.title} - ${result.product_size}` : result.title;
                return result;
              })
              setPosts(modifiedData);
            })
            .catch((error) => {
              console.error('Error fetching posts:', error);
            });
          break;
      }
    } else {
      setPosts([]);
    }
  }, [query,search_option]);

  console.log(active);


  return (
    <div className={(active) ? "search__wrapper search__wrapper--active" : "search__wrapper" } >
        <button className="close-button">
          <img src={cross} onClick={() => setActive(false)}/>
        </button>
        <select onChange={(e) => setSearchOption(e.target.value)}>
          <option value=''>Keyword</option>
          {search_options.map((option,index) => 
            (
              <option key={index} value={option.id}>{option.name}</option>
            )
          )}
        </select>
        <input
            type="text"
            placeholder="Search..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
        />
        <ul className="search__output">
          {posts.length > 0 ? (
            posts.map((result) => {
              //console.log(result);    
              return (
                <li key={result.id}>
                  <a aria-label={`Go to ${result.subtype} page`} href={result.url} dangerouslySetInnerHTML={{ __html: result.title }}></a>
                </li>
              );
            })
          ) 
          : null
          // (
          //   <li>No Results</li>
          // )
          }
        </ul>
        <button className="open-button">
          <img src={magGlass} onClick={() => setActive(true)}/>
        </button>
    </div>
  );
};

export default Search;
